import templateUrl from './trip-planner-mobile-map-view.html';
import clone from 'lodash/clone';

export const tripPlannerMobileMapViewComponent = {
    bindings: {
        directionDetails: '<',
        providerDetails: '<',
        publicRoutes: '<',
        selectedServiceType: '<',
        selectedProvider: '@',
        onBack: '&',
        getAllRoutes: '&',
        privateTravelTime: '@',
        privateTravelTimeUnit: '@',
        distance: '@'
    },

    templateUrl,

    controller: class TripPlannerMobileMapViewComponent {
        constructor(TripPlannerService) {
            'ngInject';

            this.tripPlannerService = TripPlannerService;
        }

        $onInit() {
            this.selectedDetails = {};
            this.viewProviderDetails = false;
            this.providersList = [...this.providerDetails.filtered, ...this.providerDetails.others];
        }

        viewDetails(data) {
            this.viewProviderDetails = !this.viewProviderDetails;
            this.selectedDetails = data;
        }

        backToMapView() {
            this.viewProviderDetails = !this.viewProviderDetails;
        }

        getPublicRoutes(details) {
            this.getAllRoutes({
                $event: details
            });
        }

        onRouteChange(route) {
            this._getPublicRouteDetailsObject(route);
        }

        _getPublicRouteDetailsObject({route :{steps}}) {
            this.directionDetails.type = "publicRoutes";
            this.directionDetails.steps = this.tripPlannerService.getPublicRoutesStepsObject(steps);
            this.directionDetails.stops = this.tripPlannerService.getPublicRoutesStopsObject(steps);
            this.directionDetails = clone(this.directionDetails);
        }
    }
};


// WEBPACK FOOTER //
// ./src/app/components/trip-planner/trip-planner-mobile-map-view/trip-planner-mobile-map-view.component.js